export default {
      id: "ic_aninda_bilyoner-usage",
      viewBox: "0 0 24 24",
      url: "/" + "images/icons.3.109.2.svg#ic_aninda_bilyoner-usage",
      toString: function () {
        return this.url;
      }
    }